import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useMutation } from "react-query";

import * as api from "../../services";
import AppContext from "../../appContext";
import { logging } from "../../tools";

export default function useSaveSurvey() {
  const history = useHistory();
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
    dispatch,
  } = useContext(AppContext);

  const handleInteractionId = (id) => {
    logging(`Replace interactionId to ${id}`);
    history.replace({
      state: { interactionId: id, interaction: null },
    });
  };

  const exportPublicMutation = useMutation(
    ({ questionList }) => {
      // make a new itemId for the public survey
      return api.postPublicInteraction({
        interactionId: -1,
        interactionJSON: JSON.stringify(questionList),
        name: questionList.fullQuestion,
        description: questionList.itemExtra?.description?.description ?? "",
        _public: 0,
        projectId,
        sessionId,
      });
    },
    {
      onSuccess: (data, { onSuccess }) => {
        if (data.data?.status > 0) {
          onSuccess(data.data);
          handleInteractionId(data.data.interactionId);
        }
      },
    }
  );
  const savePublicMutation = useMutation(
    ({ questionList, interactionId }) => {
      return api.postPublicInteraction({
        interactionId,
        interactionJSON: JSON.stringify(questionList),
        name: questionList.fullQuestion,
        description: questionList.itemExtra?.description?.description ?? "",
        _public: 0,
        projectId,
        sessionId,
      });
    },
    {
      onSuccess: (data, { onSuccess, interactionId }) => {
        if (data.data?.status > 0) {
          onSuccess(data.data);
          if (interactionId === -1)
            handleInteractionId(data.data.interactionId);
        }
      },
    }
  );
  const saveLocalMutation = useMutation(
    ({ questionList, interactionId }) => {
      return api.postLocalInteraction({
        clientId,
        interactionId,
        interactionJSON: JSON.stringify(questionList),
        projectId,
        sessionId,
      });
    },
    {
      onSuccess: (data, { questionList, onSuccess, interactionId }) => {
        if (data.data?.status > 0) {
          onSuccess(data.data);
          dispatch({
            type: "UPDATE_CLIENT",
            payload: { lastSaved: data.data.lastSaved },
          });
          if (interactionId === "new") handleInteractionId(questionList.itemId);
        }
      },
    }
  );
  return { saveLocalMutation, savePublicMutation, exportPublicMutation };
}
